import { zitoneoRoutes } from '../../../../property-partners-portal/zitoneo/utils/zitoneoRoutes';
import { useNotification } from '../../../../contexts/NotificationsContext';
import { useActivitySession } from '../../../../customHooks/useActivitySession';
import { FeedbackMessages } from '../../../../utils/commonVariables/messages';

/**
 * Opens the supplier hotel identified by an alert without leaving the current form.
 * @param supplierHotelId Supplier hotel ID supplied directly by the notification.
 * @param onNavigate Closes the popover after successful navigation.
 * @returns The synchronous hotel navigation action.
 */
export const useNotificationHotel = (
    supplierHotelId: number,
    onNavigate: () => void
) => {
    const session = useActivitySession();
    const { setErrorMessage } = useNotification();

    const handleGoToHotel = () => {
        if (!session.isAuthenticated || !session.isCurrent()) {
            return;
        }
        let hotelTab: Window | null = null;
        let hasOpenedHotel = false;
        try {
            if (!Number.isInteger(supplierHotelId) || supplierHotelId <= 0) {
                throw new Error('A valid supplier hotel ID is required');
            }
            hotelTab = window.open('about:blank', '_blank');
            if (!hotelTab) {
                throw new Error('The browser blocked the hotel tab');
            }
            hotelTab.opener = null;
            hotelTab.location.replace(
                new URL(
                    zitoneoRoutes.HOTEL_PRESENTATION(supplierHotelId),
                    window.location.origin
                ).href
            );
            hasOpenedHotel = true;
            onNavigate();
        } catch {
            setErrorMessage(FeedbackMessages.ERROR_OPENING_NOTIFICATION_HOTEL);
        } finally {
            if (hotelTab && !hasOpenedHotel) {
                hotelTab.close();
            }
        }
    };

    return { handleGoToHotel };
};
